import { render, staticRenderFns } from "./passIntroduce.vue?vue&type=template&id=31ff3826&scoped=true&"
import script from "./passIntroduce.vue?vue&type=script&lang=js&"
export * from "./passIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./passIntroduce.vue?vue&type=style&index=0&id=31ff3826&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff3826",
  null
  
)

export default component.exports